import React from 'react';
import Div from '../Element/Div/Div';
import { ArrayElementType } from '../../types/utils/ArrayElementType';
import styles from './Divider.module.scss';
import colors from '../../shared/colors.json';

type DividerProps = {
  /** Set the width of the divider in percentage. It defaults to 100*/
  width?: number;
  /** Color of divider */
  color?: SupportedDividerColor;
};

export const supportedDividerColors = Object.keys(colors);

export type SupportedDividerColor = ArrayElementType<
  typeof supportedDividerColors
>;

const Divider: React.FunctionComponent<DividerProps> = ({
  width = 100,
  color = 'gray300',
}) => {
  let dividerWidth;

  if (width > 100) {
    dividerWidth = 100;
  } else {
    dividerWidth = width;
  }

  const hexColor = colors[color].color;

  return (
    <Div
      style={{ width: `${dividerWidth}%`, borderTop: `1px solid ${hexColor}` }}
      className={styles.divider}
    />
  );
};

export default Divider;
